<template>
  <Button :label="label" icon="ti-plus" class="p-button-success p-button-raised"/>
</template>

<script>
export default {
  name: 'AddButton',
  props: {
    label: String
  }
}
</script>